import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import { MdArrowBack } from "react-icons/md";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import { MdViewModule } from "react-icons/md";
import { ModuleCard } from "../Components/ModuleCard";
import SpecificAPI from "../../services/SpecificApi";
import { useUserStore } from "context/useUserStore";
import localization from "services/localization";
import { useModulesStore } from "context/useModulesStore";
import { useUserRightsStore } from "context/useUserRightsStore";
import { useDepartmentsStore } from "context/useDepartmentsStore";
import { useLanguageStore } from "context/useLanguageStore";

const ModuleDashboard = () => {
  const { currentLang } = useLanguageStore();
  const navigate = useNavigate();
  const { departmentId } = useParams();
  const { modules, teachingModules, administrativeModules, managementModules } =
    useModulesStore();
  const { userCanPerform } = useUserRightsStore();
  const { appUser, isAppUserLoading } = useUserStore();
  const { departments, isDepartmentsLoading } = useDepartmentsStore();

  const role = appUser?.role || null;

  const modulesByType = modules.reduce((groups, module) => {
    const type = module.type || "Other";
    if (!groups[type]) groups[type] = [];
    groups[type].push(module);
    return groups;
  }, {});

  const handleModuleSelect = (module) => {
    // if (appUser.role === "teacher") {
    // navigate(`/services/${module.id}`);
    // } else if (appUser.role === "administrative") {
    //   navigate(`/prompt-categories/${module.id}`);
    // }

    if (role == "teacher" || role == "administrative") {
      navigate(`/prompt-categories/${module.id}/${departmentId}`);
    } else {
      navigate(`/edu-prompt/history/department/${departmentId}`);
    }
  };

  return (
    // <div
    //     className="p-6 min-h-screen"
    //     style={{
    //         backgroundColor: "var(--dashboard-bg)", // dynamic bg
    //         color: "var(--main-text-color)", // dynamic text color
    //     }}
    // >
    //     {/* Header */}
    //     <div className="d-flex flex-column align-items-center text-center mb-5">
    //         {/* Icon + Title side by side */}
    //         <div className="d-flex align-items-center gap-3 mb-2">
    //             <MdViewModule size={48} className="text-primary" />
    //             <h1
    //                 className="text-3xl font-bold m-0"
    //                 style={{ color: "var(--main-text-color)" }}
    //             >
    //                 {localization.modules || "Modules"}
    //             </h1>
    //         </div>

    //         {/* Subtitle */}
    //         <p style={{ color: "var(--card-text-color)" }}>
    //             {localization.manageYourModules || "Manage your modules"}
    //         </p>
    //     </div>

    //     {/* Modules Grid */}
    //     <div className="container">
    //         <div className="row g-4">
    //             {modules.map((module) => (
    //                 <div key={module.id} className="col-12 col-md-6 col-lg-4">
    //                     <ModuleCard
    //                         module={module}
    //                         footer={
    //                             <div className="flex justify-end mt-auto">
    //                                 <Button variant="primary" size="sm" onClick={() => handleModuleSelect(module)}>
    //                                     {localization.openModule || "Open Module"}
    //                                 </Button>
    //                             </div>
    //                         }
    //                     />
    //                 </div>
    //             ))}
    //         </div>
    //     </div>
    // </div>
    <div className="p-6 min-h-[90vh] page-top-padding main-page">
      {/* Header */}
      <div className="container mb-5">
        <div className="position-relative d-flex align-items-center">
          {/* 🔹 Left: Back Button */}
          {role !== "student" && (
            <div>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id="tooltip-back">
                    {localization.backToDepartments || "Back to Departments"}
                  </Tooltip>
                }
              >
                <span>
                  <MdArrowBack
                    size={28}
                    className="icon-btn"
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/departments")}
                  />
                </span>
              </OverlayTrigger>
            </div>
          )}

          {/* 🔹 Center: Absolute Centered Title */}
          <div className="position-absolute top-50 start-50 translate-middle d-flex align-items-center gap-3">
            <div className="title-icon-bg d-flex h-12 w-12 items-center justify-center rounded-xl shadow-md">
              <MdViewModule size={28} className="title-icon" />
            </div>

            <h1 className="text-3xl font-bold m-0 page-title header-title">
              {localization.modules || "Modules"}
            </h1>
          </div>
        </div>
      </div>

      {/* Module Sections */}
      <div className="container">
        {Object.entries(modulesByType).map(([type, group]) => {
          let allowedModules = group.filter((m) =>
            userCanPerform("modules", "read", m.id),
          );

          if (appUser?.role === "teacher") {
            allowedModules = allowedModules.filter(
              (m) => m.type === "teaching",
            );
            let selectedDep = departments.find((d) => d.id === departmentId);
            if (selectedDep) {
              allowedModules = allowedModules.filter((m) =>
                selectedDep?.module_id?.includes(m.id),
              );
            }
          } else if (appUser?.role === "administrative") {
            allowedModules = allowedModules.filter(
              (m) => m.type === "administration",
            );
          }

          allowedModules.sort((a, b) => a.name.localeCompare(b.name));

          if (allowedModules.length === 0) return null;

          return (
            <section key={type} className="mb-6 pb-4">
              {/* Section Title */}
              {/* <div className="mb-4 text-center">
                <h2
                  className="text-xl font-semibold"
                  style={{ color: "var(--main-text-color)" }}
                >
                  {type.charAt(0).toUpperCase() + type.slice(1)}
                </h2>

                <p
                  className="text-sm"
                  style={{ color: "var(--card-text-color)" }}
                >
                  {localization[type + "Subtitle"] ||
                    `${localization.modules_related_to || "Modules related to"} ${type.toLowerCase()}`}
                </p>
              </div> */}

              {/* Grid */}
              <div className="row g-4">
                {allowedModules.map((module) => (
                  <div
                    key={module.id}
                    className="col-12 col-md-6 col-lg-4 d-flex"
                  >
                    <ModuleCard
                      module={module}
                      footer={
                        <div className="flex justify-end mt-auto pt-2">
                          <Button
                            variant="primary"
                            className="action-btn"
                            size="sm"
                            onClick={() => handleModuleSelect(module)}
                          >
                            {localization.openModule || "Open Module"}
                          </Button>
                        </div>
                      }
                    />
                  </div>
                ))}
              </div>
            </section>
          );
        })}
      </div>
    </div>
  );
};

export default ModuleDashboard;
